import { gql } from '@apollo/client';
import { USER_FRAGMENT } from 'graphql/fragments';

export const GET_USER_DETAILS = gql`
  query GetUserDetails {
    businessUser {
      ...userValues
    }
  }
  ${USER_FRAGMENT}
`;
